import request from '@/utils/request'
const bpmRunTime = window.context.bpmRunTime

// 异常任务
export function getErrorTaskTree(querys = []) {
  return request({
    url: `${bpmRunTime}/runtime/bpmTaskException/v1/typeTree`,
    method: 'post',
    data: {
      querys,
    },
  })
}

export function flowInstanceTypeTree(query = []) {
  const querys = query.filter((item) => {
    return !['procDefKey', 'type_id_', 'proc_def_key_'].includes(item.property)
  })

  return request({
    url: `${bpmRunTime}/runtime/instance/v1/typeTree`,
    method: 'post',
    data: {
      querys,
    },
  })
}
